import { APIJobModel, JobStatus } from "./JobModel"

export enum MappedJobStatus {
    unprocessed = "UNPROCESSED",
    inProgress = "IN_PROGRESS",
    completed = "COMPLETED"
}

export type DataPointsToUpdate = {
    [key in MappedJobStatus]: boolean
}

export interface APIJobsPerStatusModel {
    SCHEDULED: number
    IN_PROGRESS: number
    INTERNAL_ERROR: number
    FAILED: number
    SUSPENDED: number
    ENQUEUED: number
    CANCELED: number
    EXPIRED: number
    COMPLETED: number
    PENDING: number
}

export const APIJobsPerStatusModel = {
    zeros: (): APIJobsPerStatusModel => ({
        SCHEDULED: 0,
        IN_PROGRESS: 0,
        INTERNAL_ERROR: 0,
        FAILED: 0,
        SUSPENDED: 0,
        ENQUEUED: 0,
        CANCELED: 0,
        EXPIRED: 0,
        COMPLETED: 0,
        PENDING: 0
    }),
    aggregate: (jobs: APIJobModel[]): APIJobsPerStatusModel =>
        jobs.reduce<APIJobsPerStatusModel>((map, job) => {
            if (job.status !== JobStatus.IN_CREATION) {
                map[job.status] = (map[job.status] ?? 0) + 1
            }
            return map
        }, APIJobsPerStatusModel.zeros()),
    unprocessed: (model: APIJobsPerStatusModel): number => {
        return Object.entries(model).reduce(function (total, pair) {
            const [key, value] = pair
            if (key !== JobStatus.IN_PROGRESS && key !== JobStatus.COMPLETED) {
                return total + value
            }
            return total
        }, 0)
    },
    total: (model: APIJobsPerStatusModel): number =>
        Object.values(model).reduce((accum, count) => count + accum, 0)
}
